export default __webpack_public_path__ + "static/Cinque-Terra-credit-Dom-Crossley-63ead33f8e23df53ad294608ba58d54c.jpg";